module.exports = {"130922100":"清州镇","130922101":"金牛镇","130922102":"新兴镇","130922103":"流河镇","130922104":"木门店镇","130922105":"马厂镇","130922106":"盘古镇","130922200":"上伍乡","130922201":"曹寺乡","130922203":"陈嘴乡","130922400":"青县农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130922.json
// module id = 216
// module chunks = 0